import Footer from './Components/Footer';
import NavHeader from './Components/NavHeader';
import PurpleScreen from './Components/PurpleScreen';
import SecondScreen from "./Components/SecondScreen"
import Testimonials from './Components/Testimonials';
import "./Styles/Style.scss"
function App() {
  return (
    <>
    <NavHeader/>
  <SecondScreen/>
  <PurpleScreen/>
  <Testimonials/>
  <Footer/>
    </>
  );
}

export default App;
